// @flow

import _ from 'lodash';

import Restaurant from '../Restaurant';

export default class RestaurantMarkerInfo {

  id: string;

  restaurant: Restaurant;

  position: Object = {
    lat: 0,
    lng: 0
  };

  /**
   *
   */
  defaultAnimation: number = 2;

  showInfo: boolean = false;

  isSelectable: boolean = false;

  fromRestaurant(restaurant: Restaurant) {
    this.id = restaurant.id;
    this.restaurant = restaurant;

    if (!_.isNil(restaurant.geoPt)) {
      this.position = {
        lat: restaurant.geoPt.latitude,
        lng: restaurant.geoPt.longitude,
      };
    }

    return this;
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/map/RestaurantMarkerInfo.js